module.exports = __webpack_public_path__ + "media/2022/ABC-NEWS-fde99042.png";